module.exports = __webpack_public_path__ + "static/media/oval-gradinant.4a73cf78.svg";